import React from "react";

export const LazyMainPage = React.lazy(() => import("modules/investorRole/pages/MainPage"));
